import variables from "theme/variables";
import styled from "styled-components";

const Checkbox = styled.div`
  display: inline-grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  color: ${variables.COLORS.TEXT};
`;

const CheckboxControl = styled.div`
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid ${variables.COLORS.TEXT};
  align-self: center;
  justify-self: center;

  svg {
    transition: transform 0.1s ease-in 25ms;
    transform: scale(0);
    transform-origin: bottom left;
  }
`;

const CheckboxInput = styled.div`
  display: grid;
  grid-template-areas: "checkbox";

  > * {
    grid-area: checkbox;
  }

  input {
    opacity: 0;
    width: 1em;
    height: 1em;

    &:focus + ${CheckboxControl} {
      box-shadow: 0 0 0 0.05em #fff, 0 0 0.15em 0.1em ${variables.COLORS.PRIMARY};
    }

    &:checked + ${CheckboxControl} svg {
      transform: scale(1);
    }
  }
`;

const CheckboxStyles = {
  Checkbox,
  CheckboxControl,
  CheckboxInput,
};

export default CheckboxStyles;
